import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify.ts'
import router from './router/index.ts'


createApp(App)
  .use(router) // <-- usa router
  .use(vuetify) // si tienes Vuetify
  .mount('#app')